import { useState, useEffect } from 'react'
import { familyGroupService } from '../services'

export const useFamilyRequests = () => {
  const [sentRequests, setSentRequests] = useState<any[]>([])
  const [receivedRequests, setReceivedRequests] = useState<any[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    loadRequests()
  }, [])

  const loadRequests = async () => {
    setLoading(true)
    setError(null)
    try {
      const [sentResp, receivedResp] = await Promise.all([
        familyGroupService.getSentRequests(),
        familyGroupService.getReceivedRequests()
      ])
      setSentRequests(sentResp.data)
      setReceivedRequests(receivedResp.data)
    } catch (err: any) {
      setError(err.message || 'Error al cargar las solicitudes')
    } finally {
      setLoading(false)
    }
  }

  const handleAccept = async (requestId: number, applicantId: number, familyId: number) => {
    setLoading(true)
    setError(null)
    try {
      await familyGroupService.acceptRequest(requestId, applicantId, familyId)
    } catch (err: any) {
      setError(err.message || 'Error al aceptar la solicitud')
    } finally {
      await loadRequests()
      setLoading(false)
    }
  }

  const handleReject = async (requestId: number, applicantId: number, familyId: number) => {
    setLoading(true)
    setError(null)
    try {
      await familyGroupService.rejectRequest(requestId, applicantId, familyId)
    } catch (err: any) {
      setError(err.message || 'Error al rechazar la solicitud')
    } finally {
      await loadRequests()
      setLoading(false)
    }
  }

  return {
    sentRequests,
    receivedRequests,
    loading,
    error,
    handleAccept,
    handleReject,
    refresh: loadRequests
  }
} 